import React from "react";

import "../styles.scss";
import "../scripts";

import {
  secondaryBlock,
  SecondaryBlockSize,
  KameleonElement,
  SecondaryBlockConfig,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box } from "theme-ui";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContactType, layoutOptions } from "./types/prop-types";

/** Contact Secondary */
const blockConfig: SecondaryBlockConfig = {
  blockSize: SecondaryBlockSize.Small,
};

export const Contact = secondaryBlock<ContactType>(
  blockConfig,
  ({
    icon,
    text,
    contactLink,
    contact,
    primaryButtonText,
    primaryButtonLink,
  }: ContactType) => (
    <Box
      sx={{ marginTop: "1.5rem" }}
      className="secondary-contact-small-v1 margin-section-small direction-vertical"
    >
      <Variants.BoxGrey className="quote-medium padding-xxsmall horizontal-on-mobile">
        <Box className="contact-icon-wrapper icon-embed-xxsmall">
          <Variants.IconTiny hasBg={false} icon={icon} />
        </Box>
        <Box className="testimonial25_client-info">
          {/* styling still being used */}
          <Variants.ParagraphSmall>{text}</Variants.ParagraphSmall>
          <Variants.ParagraphSmall>
            <Variants.LinkUnderline
              as="strong"
              sx={{ fontWeight: "bold" }}
              href={contactLink}
            >
              {contact}
            </Variants.LinkUnderline>
          </Variants.ParagraphSmall>
        </Box>
      </Variants.BoxGrey>
      <Box className="margin-top margin-15 button-group">
        <Variants.LinkButton className="button" href={primaryButtonLink}>
          {primaryButtonText}
        </Variants.LinkButton>
      </Box>
    </Box>
  )
);

Contact.defaultProps = getDefaultProps<ContactType>(defaults);

export const Element: KameleonElement = {
  component: Contact,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
